import { useTranslation } from "react-i18next";
import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "../ui/primitives.js";

/** Offers the new version when the service worker has one; never reloads by itself. */
export function UpdatePrompt() {
  const { t } = useTranslation();
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  if (!needRefresh) return null;
  return (
    <div
      role="status"
      className="fixed inset-x-4 bottom-4 z-20 mx-auto flex max-w-md items-center justify-between gap-3 rounded-xl border border-line bg-surface p-4 shadow-lg"
    >
      <p className="text-sm">{t("pwa.update")}</p>
      <Button onClick={() => void updateServiceWorker(true)}>{t("pwa.reload")}</Button>
    </div>
  );
}
